module.exports = __webpack_public_path__ + "static/media/drum.ea1fc8dc.png";